import React, { forwardRef, useEffect, useRef, useState } from "react";
import './ValuesSection.css';

const ValuesSection = forwardRef(({ scrollToNextSection }, ref) =>  {
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [isScrolling, setIsScrolling] = useState(false);
  let scrollTimeout = useRef(null); // Timeout para evitar conflitos

  const [valores,setValores]=useState([]);

  useEffect(() => {
    // Caminho para o JSON dentro da pasta public
    fetch('/assets/json/valores.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro ao carregar o arquivo JSON');
        }
        return response.json();
      })
      .then((jsonData) => {
        setValores(jsonData);
      })
      .catch((error) => {
        console.error('Erro ao buscar o arquivo JSON:', error);
      });
  }, []);

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      setIsScrolling(true);

      // Limpa o temporizador anterior se houver
      clearTimeout(timeoutId);

      // Configura um temporizador para iniciar a transição de opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(0); // Começa a desaparecer gradativamente
      }, 10); // Inicia a transição de opacidade após 100ms

      // Configura um temporizador para restaurar a opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(1); // Restaura a opacidade
        setIsScrolling(false);
      }, 200); // Tempo para restaurar a opacidade após 1 segundo de inatividade
    };

    // Adiciona o ouvinte de evento de rolagem
    window.addEventListener('scroll', handleScroll);

    // Remove o ouvinte de evento quando o componente é desmontado
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
    const handlePrev = () => {
        if(sliderRef.current) {
            sliderRef.current.scrollBy({
                left: -sliderRef.current.offsetWidth,
                behavior:"smooth"
            })
            if(currentIndex > 0) {
                setCurrentIndex((prevIndex) => prevIndex - 1);
            }
        }
    };

    const handleNext = () => {
        if(sliderRef.current) {
            sliderRef.current.scrollBy({
                left: sliderRef.current.offsetWidth,
                behavior:"smooth"
            })
            if(currentIndex < 3) {
                setCurrentIndex((prevIndex) => prevIndex + 1);
            }
        }
    };

     // Atualizar o índice com base na posição do scroll
     const handleScroll = () => {
      if (scrollTimeout.current) {
          clearTimeout(scrollTimeout.current); // Limpa o timeout anterior
      }

      // Define um timeout para que o índice seja atualizado após o scroll parar
      scrollTimeout.current = setTimeout(() => {
          if (sliderRef.current) {
              const index = Math.round(sliderRef.current.scrollLeft / sliderRef.current.offsetWidth);
              setCurrentIndex(index);
          }
      }, 30); // Aguarda 100ms para garantir que o scroll foi concluído
  };

  // Adiciona o listener ao scroll quando o componente é montado
  useEffect(() => {
      const slider = sliderRef.current;
      if (slider) {
          slider.addEventListener('scroll', handleScroll);
      }

      // Remove o listener quando o componente é desmontado
      return () => {
          if (slider) {
              slider.removeEventListener('scroll', handleScroll);
          }
          if (scrollTimeout.current) {
              clearTimeout(scrollTimeout.current);
          }
      };
  }, []);
  return (
    <section id={"values-section"} className="values-section" ref={ref}>
        <div className="content">
            <h2>VALORES</h2>
            <div className="slider-wrapper">
              <div ref={sliderRef} className="values-wrapper">
                  <div className="card">
                      <label>MEIA DIÁRIA <span>SEM EQUIPAMENTO</span></label>
                      <span id="total">(TOTAL DE 05 HORAS)</span>
                      <span id="horario">08h-13h OU 14h-19h</span>
                      <p>R$ {valores[0]}</p>
                      <span id="extra">R$ 100 / Hora Extra*</span>
                  </div>
                  <div id="divider"></div>
                  <div className="card">
                      <label>MEIA DIÁRIA <span>COM EQUIPAMENTO</span></label>
                      <span id="total">(TOTAL DE 05 HORAS)</span>
                      <span id="horario">08h-13h OU 14h-19h</span>
                      <p>R$ {valores[1]}</p>
                      <span id="extra">R$ 100 / Hora Extra*</span>
                  </div>
                  <div id="divider"></div>
                  <div className="card">
                      <label>DIÁRIA COMPLETA <span>SEM EQUIPAMENTO</span></label>
                      <span id="total">(TOTAL DE 10 HORAS)</span>
                      <span id="horario">09h-19h (ou a combinar)</span>
                      <p>R$ {valores[2]}</p>
                      <span id="extra">R$ 100 / Hora Extra</span>
                      
                  </div>
                  <div id="divider"></div>
                  <div className="card">
                      <label>DIÁRIA COMPLETA <span>COM EQUIPAMENTO</span></label>
                      <span id="total">(TOTAL DE 10 HORAS)</span>
                      <span id="horario">09h-19h (ou a combinar)</span>
                      <p>R$ {valores[3]}</p>
                      <span id="extra">R$ 100 / Hora Extra</span>
                      
                  </div>

              </div>
              <div className="control-wrapper">
                <button onClick={handlePrev} id="slider-control"><img src="/assets/icons/angle-down.png"/></button>
                <button onClick={handleNext} id="slider-control"><img src="/assets/icons/angle-down.png"/></button>
              </div>
            </div>
            <div className="list-index">
                <div className={`${currentIndex==0 ? 'current' : 'index'}`}></div>
                <div className={`${currentIndex==1 ? 'current' : 'index'}`}></div>
                <div className={`${currentIndex==2 ? 'current' : 'index'}`}></div>
                <div className={`${currentIndex==3 ? 'current' : 'index'}`}></div>
            </div>
            <p id="parcelas">PARA PROJETOS E CAMPANHAS ESPECIAIS, <span>ENTRE EM CONTATO COM A GENTE</span></p>
            
            <div className="condicoes-wrapper">
            <h2>CONDIÇÕES GERAIS</h2>
                <p>*Para hora extra em meia diária, consultar disponibilidade · Para locação após 22h, verificar disponibilidade e valores · O estúdio deve ser entregue limpo e organizado, sendo a taxa de limpeza R$150, quando necessário · Qualquer tipo de dano e equipamentos ou estrutura será repassado ao responsável pela locação · Reservas mediante antecipação de R$200 · Cancelamentos serão aceitos em até 48h antes da data agendada · Não nos responsabilizamos por equipamentos de terceiros deixados no estúdio · Para finais de semana e feriados, a taxa adicional é de R$200.</p>
            </div>
        </div>
        <div className="transaction">
          <div className="transaction-wrapper">
            <img id="bg-angle-down" src="/assets/img/scroll-down.png"/>
            <button onClick={scrollToNextSection} style={{
          opacity,
          transition: 'opacity 0.2s ease' // Animação de transição de opacidade
        }}><span>SCROLL DOWN</span><img id="angle" src="/assets/icons/angle-down.png"/></button>
          </div>
           
           
        </div>
    </section>
  );
});

export default ValuesSection;
